import { AccordionProps, styled } from '@mui/material';
import MuiAccordion, { accordionClasses } from '@mui/material/Accordion';
import Divider from '@mui/material/Divider';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Popper from '@mui/material/Popper';
import Stack from '@mui/material/Stack';

export const StyledAccordion = styled((props: AccordionProps) => (
  <MuiAccordion
    disableGutters
    elevation={0}
    square
    {...props}
  />
))(() => ({
  padding: 0,
  background: 'transparent',
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
  [`.${accordionClasses.region}`]: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const StyledDivider = styled((props) => (
  <Divider
    flexItem
    {...props}
  />
))(({ theme }) => ({
  marginBlock: theme.spacing(1),
  backgroundColor: theme.palette.border.secondary,
  height: 1,
}));

export const StyledPopper = styled(Popper)(({ theme }) => ({
  width: theme.spacing(83.75),
  zIndex: 1,
  background: theme.palette.background.primary,
  borderRadius: theme.shape.borderRadius * 4,
  boxShadow: theme.customShadows.lg,
}));

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const StyledListItemButton = styled(ListItemButton)(() => ({
  color: 'red',
  '&:hover': {
    background: 'transparent',
  },
})) as typeof ListItemButton;

export const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  color: theme.palette.utility.gray700,
}));

export const StyledStack = styled(Stack)(() => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
}));
